export interface IUser {
  id: number;
  name: string;
  email: string;
  type: enUserType;
  cpfcnpj: string;
  id_leg: number;
  clicodeduzz: number;
  isFetching: boolean;

  avatar?: string;

  coursesCount?: {
    has_one: number;
    course_hash?: string;
  };
}

export enum enUserType {
  'learner' = 0,
  'producer' = 1,
}

export interface IUserToken {
  token: string;
  refresh_token: string;
}
